<template>
  <main class="account-page">
    <TopBar :page-header="$t('accountPage.account')" />
    <LanguageChoice />
    <div class="container"> 
      <div class="form"
           style="z-index: 100;"
      > 
        <h2>{{ $t('accountPage.chooseAccount') }}</h2>
        <br>
        <div class="custom-select" 
             @click="toggleCustomerOptions"
        > 
          <div class="select-selected"> 
            <span>{{ chosenCustomer.Name }} </span>
          </div> 
          <div :class="`select-items ${hideClass}`"> 
            <div v-for="customer in customers"
                 :key="customer.Id" 
                 style="z-index: 100;"
                 @click="setCustomer(customer.Id)"
            > 
              {{ customer.Name }} 
            </div> 
          </div> 
        </div> 
      </div> 
    </div>
    <div class="container">
      <div class="form">
        <form @submit.prevent="handleChangePassword">
          <div class="passwordDiv">
            <div>
              <input :type="passwordType"
                     name="password"
                     :placeholder="$t('accountPage.password')"
                     :value="password"
                     @change="setPassword"
              >

              <input :type="passwordType"
                     name="confirmPassword"
                     :placeholder="$t('accountPage.confirmPassword')"
                     :value="repeatPassword"
                     @change="setRepeatPassword"
              >
            </div>

            <button v-if="repeatPassword != ''"
                    class="clearButtonRepPass"
                    type="button"
                    @click="clearPassword('rep')"
            >
              <span class="material-icons">clear</span>
            </button>
            <button v-if="password != ''"
                    class="clearButton"
                    type="button"
                    @click="clearPassword('pass')"
            >
              <span class="material-icons">clear</span>
            </button>
            <button class="iconButton"
                    type="button"
                    @click="showPassword"
            >
              <span class="material-icons">{{ eyeIcon }}</span>
            </button>
          </div>
          <button type="submit"
                  class="btn"
          >
            {{ $t("accountPage.changePassword") }}
          </button>
        </form>
      </div>
    </div>
    
    <div class="container">
      <div class="form">
        <form action="#"
              class="logout-form"
              @submit.prevent="handleLogoutSubmit"
        >
          <button type="submit"
                  class="btn"
          >
            {{ $t("accountPage.logout") }}
          </button>
        </form>
      </div>
    </div>
  </main>
</template>

<script setup>
import TopBar from "../components/TopBar.vue";
import LanguageChoice from "../components/LanguageChoice.vue";
import { ref, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const password = ref('');
const repeatPassword = ref('');
const passwordType = computed(() => store.state.account.passwordType);
const eyeIcon = computed(() => store.state.account.eyeIcon);
const customers = computed(() => !store.state.account.me.Customers ? []: store.state.account.me?.Customers ); 
const chosenCustomer = computed(() => store.state.account.chosenCustomer); 
 
 
function setCustomer(id){ 
  store.commit('tasks/setTaskData', []);
  store.dispatch('account/setChosenCustomer', id) 
} 

function handleLogoutSubmit() {
  localStorage.clear("token");
  store.commit("sidebar/sidebarLogOut");
  window.location.href = "/login";
}

function showPassword() {
  store.dispatch("account/toggleShowPassword");
}

function setPassword(e){
  password.value = e.target.value;
}

function setRepeatPassword(e){
  repeatPassword.value = e.target.value;
}

const clearPassword = (type) => {
  if (type == "pass") store.commit("account/clearPassword");
  else store.commit("account/clearRepeatPassword");
}

function handleChangePassword() {
  var parameters = {
    "password": password.value,
    "repeatPassword": repeatPassword.value
  };
  store.dispatch("account/handleChangePassword", parameters);
}

const hideClass = ref('select-hide') 
function toggleCustomerOptions(){ 
  if(hideClass.value != ""){ 
    hideClass.value = '' 
  } 
  else{ 
    hideClass.value = 'select-hide' 
  } 
} 
</script>

<style lang="scss" scoped>
@import "../scss/buttons.scss";
@import "../scss/input.scss";


@mixin message($fontcolor: #90a4ae) {
  color: $fontcolor;
  text-align: center;
  font-size: 14px;
}
.account-page {
  height: 100vh;
  overflow-y: scroll;
  color: #000000;
  background: #ffffff;
  font-family: "Be Vietnam Pro", sans-serif;
}
.iconButton {
  position: absolute;
  top: 0;
  padding: 1px;
  right: 60px;
  z-index: 2;
  border: none;
  top: 55px;
  height: 30px;
  cursor: pointer;

  transform: translateX(4px);
}
.clearButton {
  position: absolute;
  top: 0;
  padding: 1px;
  right: 20px;
  z-index: 2;
  border: none;
  top: 55px;
  height: 30px;
  cursor: pointer;
  transform: translateX(2px);
}
.clearButtonRepPass {
  position: absolute;
  top: 0;
  padding: 1px;
  right: 20px;
  z-index: 2;
  border: none;
  top: 130px;
  height: 30px;
  cursor: pointer;
  transform: translateX(2px);
}
.container {
  padding: 4% 0 0;
  width: 365px;
  margin: auto;
}

.passwordDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  vertical-align: middle;

  .singleColumn {
    display: flex;
    flex-direction: column;
    margin-right: 1rem;
  }
}

.form {
  position: relative;
  z-index: 1;
  max-width: 350px;
  margin: 0 auto 100px;
  padding: 45px;
  background: #E6E6E6;
  border-radius: 10px;

  h2 {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
  }
}

.form {
  input {
    @include input100percent;
    background: #ffffff;
    color: #000000;
    font-family: "Be Vietnam Pro", sans-serif;
    font-weight: 400;
    border-radius: 5px;

    &:focus {
      border-radius: 5px;
      outline-color: var(--primary);
    }
  }

  .btn {
    @include btn100percent;
    background: #4F0207;
    color: #ffffff;
    font-family: "Be Vietnam Pro", sans-serif;
    font-size: 14px;
    font-weight: 600;
    text-transform: none;
    border-radius: 999px;

    &:hover {
      border-radius: 999px;
    }
  }

  .message {
    @include message;

    a {
      text-decoration: none;
      color: #00bfa5;
    }
  }
}

.form .register-form {
  display: none;
}

@media (max-width: 768px) {
  .container {
    padding: 8% 0 0;
    width: 275px;
    margin: auto;
  }
  .clearButton {
    top: 44px;
    right: 2px;
  }
  .clearButtonRepPass {
    top: 110px;
    right: 2px;
  }
  .iconButton {
    top: 35px;
    right: 35px;
  }

  .form {
    position: relative;
    z-index: 1;
    max-width: 270px;
    margin: 0 auto 100px;
    padding: 25px;
    background: #E6E6E6;
    border-radius: 10px;
  }
}


     /* The container must be positioned relative: */ 
     .custom-select { 
      width: 100%; 
      height:60px; 
      line-height: 45px;
      position: relative; 
    } 
     
    .custom-select select { 
      display: none; /*hide original SELECT element: */ 
    } 
     
    .select-selected { 
      background-color: #4F0207; 
      color: #ffffff; 
    } 

    .select-selected span{

      display: inline-block;
      vertical-align: middle;
      line-height: normal;
    }
     
    /* Style the arrow inside the select element: */ 
    .select-selected:after { 
      position: absolute; 
      content: ""; 
      top: 30px; 
      right: 10px; 
      width: 0; 
      height: 0; 
      border: 6px solid transparent; 
      border-color: #fff transparent transparent transparent; 
    } 
     
    /* Point the arrow upwards when the select box is open (active): */ 
    .select-selected.select-arrow-active:after { 
      border-color: transparent transparent #fff transparent; 
      top: 7px; 
    } 
     
    /* style the items (options), including the selected item: */ 
    .select-items div { 
      line-height: normal;
      height:100%; 
      color: #000000; 
      padding: 8px 16px; 
      border: 1px solid transparent; 
      border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent; 
      cursor: pointer; 
    } 
    .select-selected { 
      height:100%; 
      color: #ffffff; 
      padding: 8px 16px; 
      border: 1px solid transparent; 
      border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent; 
      cursor: pointer; 
    } 
     
    /* Style items (options): */ 
    .select-items { 
      position: absolute; 
      background-color: #E6E6E6; 
      top: 100%; 
      left: 0; 
      right: 0; 
      z-index: 99; 
    } 
     
    /* Hide the items when the select box is closed: */ 
    .select-hide { 
      display: none; 
    } 
     
    .select-items div:hover, .same-as-selected { 
      background-color: rgba(0, 0, 0, 0.1); 
    }  
</style>
